import React from "react";

const InventoryStatus = () => {
  return <div>InventoryStatus</div>;
};

export default InventoryStatus;
